/**
 * function to return currency ID or name based on the passed value (which can also be name or ID)
 * */
const findAdjustmentCurrency = (currencyValue, currencies, returnName = false) => {
  const searchName = isNaN(parseInt(currencyValue));
  const currency = currencies.find((item) =>
    searchName ? item.data === currencyValue : parseInt(item.id) === parseInt(currencyValue)
  );

  if (currency) {
    return returnName ? currency.data : currency.id;
  }
  return null;
};

/**
 * function to create adjustments object with initial values
 * or can optionally be passed data to populate the object for existing loads
 * */
export const generateAdjustmentsObject = (data = {}, currencies = [], returnCurrencyName = false, isRPA = false) => {
  // data is sometimes passed in Headers object
  const [headerData] = data.Headers || [];

  return [
    {
      name: 'freightCharges',
      display: 'Freight Charges',
      amount: headerData?.FreightChargesAmount ?? data.freightCharges ?? '',
      currency:
        findAdjustmentCurrency(
          headerData?.FreightChargesCurrency ?? data.freightChargescurrency,
          currencies,
          returnCurrencyName
        ) ?? '',
      minValidAmount: 55,
      maxValidAmount: 9999,
      required: false,
    },
    {
      name: 'insuranceCharges',
      display: 'Insurance Charges',
      amount: headerData?.InsuranceChargesAmount ?? data.insuranceCharges ?? '',
      currency:
        findAdjustmentCurrency(
          headerData?.InsuranceChargesCurrency ?? data.insuranceChargescurrency,
          currencies,
          returnCurrencyName
        ) ?? '',
      required: false,
    },
    {
      name: 'vatAdjustment',
      display: 'VAT Adjustment',
      amount: headerData?.VatAdjustmentsAmount ?? data.vatAdjustment ?? '',
      currency:
        findAdjustmentCurrency(
          headerData?.VatAdjustmentsCurrency ?? data.vatAdjustmentcurrency,
          currencies,
          returnCurrencyName
        ) ?? '',
      required: false,
    },
    {
      name: 'otherCharges',
      display: 'Other Additions',
      amount: headerData?.OtherAdditionsAmount ?? data.otherCharges ?? '',
      currency:
        findAdjustmentCurrency(
          headerData?.OtherAdditionsCurrency ?? data.otherChargescurrency,
          currencies,
          returnCurrencyName
        ) ?? '',
      required: false,
    },
    {
      name: 'invoiceDiscount',
      display: 'Other Deductions',
      amount: headerData?.OtherDeductionsAmount ?? data.invoiceDiscount ?? '',
      currency:
        findAdjustmentCurrency(
          headerData?.OtherDeductionsCurrency ?? data.invoiceDiscountcurrency,
          currencies,
          returnCurrencyName
        ) ?? '',
      required: false,
    },
  ];
};

export const incotermAllowsAdjustments = (incoterm) =>
  !(!incoterm || incoterm?.length === 0 || (parseInt(incoterm) > 8 && parseInt(incoterm) < 11));

export const incotermRequiresAdjustments = (incoterm) => ['1', '2', '11', '12'].includes(incoterm);

export const isAdjustmentsRoute = (id) => {
  switch (id) {
    case 3:
    case 4:
    case 12:
    case '3':
    case '4':
    case '12':
      return false;
    default:
      return true;
  }
};
